import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { useCategoryPageQueryParams } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageQueryParams";
import { LoggedOutCategoryPageLayoutElementRenderer } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageLayoutElements/__internal__/LoggedOutCategoryPageLayoutElementRenderer";
import { useLoggedOutCategoryPageLayoutElementsResponse } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageLayoutElementsResponse";
var ELIGIBLE_SHOWROOM_BANNER_PAGE = 1;
export var LoggedOutCategoryPageLayoutElements = function(param) {
    var placement = param.placement;
    var _useLoggedOutCategoryPageLayoutElementsResponse = useLoggedOutCategoryPageLayoutElementsResponse(), layoutElementsData = _useLoggedOutCategoryPageLayoutElementsResponse.data;
    var oneIndexedPageNumber = useCategoryPageQueryParams().oneIndexedPageNumber;
    var layoutElements = layoutElementsData === null || layoutElementsData === void 0 ? void 0 : layoutElementsData.layout_elements;
    var requestId = layoutElementsData === null || layoutElementsData === void 0 ? void 0 : layoutElementsData.request_id;
    if (layoutElements === undefined) {
        return null;
    }
    var filteredLayoutElements = layoutElements.filter(function(layoutElement) {
        return placement === layoutElement.placement;
    });
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: filteredLayoutElements.map(function(layoutElement, index) {
            return /*#__PURE__*/ _jsx(React.Fragment, {
                children: /*#__PURE__*/ _jsx(LoggedOutCategoryPageLayoutElementRenderer, {
                    layoutElement: layoutElement,
                    requestId: requestId,
                    shouldDisplayShowroomBanner: oneIndexedPageNumber === ELIGIBLE_SHOWROOM_BANNER_PAGE,
                    placement: layoutElement.placement
                })
            }, "logged-out-category-page-carousel-".concat(layoutElement.type, "-").concat(index));
        })
    });
};
